export class ApiClientError extends Error {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
  }

}
export class ApiClientConfigError extends ApiClientError {
  constructor(reason) {
    super(reason);
  }

}
export class ApiClientRequestError extends ApiClientError {
  constructor(reason) {
    super(reason);
  }

}
export class ApiClientResponseError extends ApiClientError {
  constructor(caught) {
    super();
    this.status = void 0;
    this.params = void 0;
    var response = caught.response;

    if (response) {
      this.status = response.status;
      var params = response.data;

      if (params) {
        var _params$error_descrip;

        var message = (_params$error_descrip = params.error_description) !== null && _params$error_descrip !== void 0 ? _params$error_descrip : params.message;
        if (message) this.message = message;
        this.params = params;
      }
    } else this.message = caught.message;
  }

}